import { useEffect } from 'react';
import { useStore } from '../../lib/hooks/useStore';
import { useSessionManager } from '../../lib/hooks/useSessionManager';
import { useKeypressLogger } from '../../lib/hooks/useKeypressLogger';
import logger from '../../lib/helpers/logger';
import pageIds from '../../lib/constants/page-ids';

export function usePageRendererHooks() {
	const {
		uiStore: { setTitle, handleNavigation, setLogoImages, canCancel },
		configStore: { config, getString, loadConfig, isConfigLoaded, currentPage, setCurrentPageId, pageParams },
		kioskStore: {
			hubConnection,
			createHubConnection,
			connectionStatus,
			authenticate,
			isKioskAuthorized,
			sendAlert,
			legacyPostCashBoxRemoved,
			legacyIsApiActive,
			legacyIsMaintenanceMode,
		},
	} = useStore();

	useEffect(() => {
		if (!isKioskAuthorized) authenticate();
	}, [authenticate, isKioskAuthorized]);

	useEffect(() => {
		if (!hubConnection && isKioskAuthorized) {
			createHubConnection();
			logger.debug.log(`SignalR Status: ${connectionStatus}`);
		}
	}, [connectionStatus, createHubConnection, hubConnection, isKioskAuthorized]);

	useEffect(() => {
		if (!isConfigLoaded) {
			loadConfig();
			setLogoImages();
		} else {
			const effectiveNoTranslate = currentPage?.id === pageIds.languages ? false : currentPage?.noTranslate;
			document.title = currentPage?.title ? getString(currentPage?.title, effectiveNoTranslate) : '';
			setTitle(document.title);
		}
	}, [currentPage?.title, currentPage?.noTranslate, isConfigLoaded, loadConfig, setLogoImages, setCurrentPageId, setTitle, getString]);

	useSessionManager();
	useKeypressLogger();

	return {
		config,
		getString,
		currentPage,
		isConfigLoaded,
		handleNavigation,
		pageParams,
		isKioskAuthorized,
		sendAlert,
		legacyPostCashBoxRemoved,
		legacyIsApiActive,
		legacyIsMaintenanceMode,
		canCancel,
	};
}
